import { setTerm } from './helpers';

export const setEarlyAccess = setTerm('is_early_access_enabled');
